



















import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip } from '@folky-tools/mdbvue';
import BusinessBasicData from '@/components/businesses/BusinessBasicData.vue';
import { usersService, businessesService, authorizationManagerService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Business } from '@/models/businesses/business';
import { GenericResult } from '@/models/common/results/generic-result';
import { UserPermissionAction, UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        BusinessBasicData,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class NewBusinessView extends Vue {
    private business: Business = new Business();
    private savingBusiness: boolean = false;

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.newBusinessView.title');
        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.New
            })
        );
    }

    private async saveBusiness(): Promise<void> {
        this.savingBusiness = true;

        if ((this.$refs.businessBasicData as any).hasErrors()) {
            this.savingBusiness = false;
            return;
        }

        try {
            const newBusinessResult: GenericResult = await businessesService.newBusiness(this.business);
            if (newBusinessResult.result) {
                notificationsService.showToastSuccessNotification('views.businesses.newBusinessView.actions.save.success.notification');
                authorizationManagerService.addOrUpdatePermission(UserPermissionAction.Owner, UserEntityPermissionsType.Businesses, newBusinessResult.id);

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasCreated,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.New,
                        entityId: newBusinessResult.id
                    })
                );

                this.$router.push('/businesses');
                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBusiness = false;
        }
    }
}
